import React from 'react'

import PosMonitor from 'pages/admin/sql/PosMonitor'

/**
 * Монитор кассы для партнёра.
 *
 * Экран тот же, что в админке, но по своим клиентам и без сырой базы:
 * в списке логинов — владельцы точек, закреплённых за партнёром
 * (`/partner/owners`), в списке точек — те же точки, а вкладок «События» и
 * «SQL» нет — произвольные запросы в базу клиента партнёру не положены.
 */
function Index() {
	return (
		<PosMonitor
			basePath='/partner'
			usersUrl='/partner/owners'
			posesUrl='/partner/sql/poses'
			allowWrite={false}
			allowSql={false} />
	)
}

export default Index
